// vim: set ts=2 sw=2 et tw=80 ft=javascript:
/**
 * Copyright (C) 2015 Minted Inc.
 * All Rights Reserved
 * CTAG:COMMUNITY:STORES
 */

var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/underscore-1.8.2.min': '_',
  'templito:community':[],
  'minted:config/stores_shared_constants_config': [],
  'minted:view/info_dialog': [],
  'minted:view/storefront_tools/constants': [],
})(this, function (m_module, Backbone, $, _) {

  "use strict";

  var M = m_module.M;
  M.Community = M.Community || {};
  M.Community.View = M.Community.View || {};
  M.View = M.View || {};
  M.View.StorefrontTools = M.View.StorefrontTools || {};

  var errorDict = M.Config['StoresSharedConstantsConfig']['validation_error'];

  M.Community.View.CurateLink = Backbone.View.extend({

    CURATE_STATUS_TO_ASSETS_DICT: {
      'false': {
        class: 'add',
        text: 'add to my store',
        track_event: M.GA.TRACK_EVENT_ACTION.CURATE_LINK_CLICK
      },
      'true': {
        class: 'added',
        text: 'added to store',
        track_event: M.GA.TRACK_EVENT_ACTION.UNCURATE_LINK_CLICK
      },
      'remove': {
        class: 'remove',
        text: 'remove',
        track_event: M.GA.TRACK_EVENT_ACTION.UNCURATE_LINK_CLICK
      }
    },

    model: M.Community.Model.CurateLink,

    template: M.Template.Community.CurateLink,

    events: {
      'click div.curatorLink': 'handleCurateLinkClick',
      'mouseenter div.curatorLink': '_hoverCurateLink',
      'mouseleave div.curatorLink': '_unhoverCurateLink'
    },

    REMOVE: 'remove',

    initialize: function() {
      this.$el = $(this.el);
      _.bindAll(this, 'toggleCurate', '_hoverCurateLink',
        '_unhoverCurateLink', 'render', '_handleException');
      this.model.bind('change', this.render);
      this.model.bind('curate_exception', this._handleException);
    },

    render: function() {
      M.required(this.options.$containerEl);

      // Used for trackAPI
      M.required(this.options.uid);
      M.required(this.options.page);
      M.required(this.options.trackEventFeature);

      var templateVars = {};
      var toCurate = this.model.get('is_curated');
      if (typeof toCurate === 'undefined') {
        this.renderLoadingSpinner();
        this.model.fetch();
        return this;
      }

      templateVars['statusClass'] =
        this.CURATE_STATUS_TO_ASSETS_DICT[toCurate]['class'];
      templateVars['statusText'] =
        this.CURATE_STATUS_TO_ASSETS_DICT[toCurate]['text'];

      this.options.$containerEl.html(this.$el);
      this.$el.html(this.template(templateVars));
      this.delegateEvents();
      return this;
    },

    renderLoadingSpinner: function() {
      var loadingEl = $('<div>').addClass('loadingSpinner');
      this.$el.html(loadingEl);
      this.options.$containerEl.html(this.$el);
      return this;
    },

    _trackCurateEvent: function() {
      var trackEventFeature = this.options.trackEventFeature;
      var toCurate = this.model.get('is_curated');
      var trackEventAction =
        this.CURATE_STATUS_TO_ASSETS_DICT[toCurate]['track_event']
      var trackSku = this.model.get('sku');
      var trackUser = this.options.uid;
      var trackPage = this.options.page;

      // Send event for TrackAPI
      var trackData = {
        'feature': trackEventFeature,
        'event': trackEventAction,
        'page': trackPage,
        'sku': trackSku,
        'user': trackUser
      };

      M.sendTrackAPI(trackData);
    },

    /**
     * updates the class and text on hover. This is a working around of reusing
     * render. When render is called the dom is lost and the events are cleaned,
     * so that I could not restore the button to 'added to store'.
     *
     */
    _updateClassAndText: function(className, text) {
      var baseClasses = 'sprite curateButton';
      var newClasses = baseClasses + ' ' + className;
      this.$el.find('img.curateButton').removeClass()
        .addClass(newClasses);
      this.$el.find('span.statusText').text(text);
    },

    _updateClassAndTextByState: function(state){
      var className =
        this.CURATE_STATUS_TO_ASSETS_DICT[state]['class'];
      var text = this.CURATE_STATUS_TO_ASSETS_DICT[state]['text'];
      this._updateClassAndText(className, text);
    },

    handleCurateLinkClick: function(e) {
      this._trackCurateEvent();
      this.toggleCurate();
    },

    toggleCurate: function(e) {
      this.model.toggleCurate();
    },

    _hoverCurateLink: function(e) {
      if (this.model.isCurated()) {
        this._updateClassAndTextByState(this.REMOVE);
      }
    },

    _unhoverCurateLink: function(e) {
      var isCurated = this.model.isCurated();
      if (isCurated) {
        this._updateClassAndTextByState(isCurated);
      }
    },

    /*
     * This dialog will reload the window when user clicks on 'ok' to get proper
     * curate status of the product on the page.
     */
    _handleException: function() {
      // Render error dialog
      var error_code = this.model.get('error_code');
      var dialog_title =
        M.View.StorefrontTools.Constants.DialogTitle['UNEXPECTED_ERROR'];
      var error_msg =
        M.View.StorefrontTools.Constants.ErrorMsg['unexpectedError'];

      if (error_code === errorDict['unable_to_curate_product']['error_code']) {
        dialog_title =
          M.View.StorefrontTools.Constants.DialogTitle['UNABLE_TO_CURATE_PRODUCT'];
        error_msg =
          M.View.StorefrontTools.Constants.ErrorMsg['unableToCurateProduct'];
      } else if (error_code ===
          errorDict['product_already_uncurated']['error_code']) {
        dialog_title =
          M.View.StorefrontTools.Constants.DialogTitle['UNABLE_TO_REMOVE_PRODUCT'];
        error_msg =
          M.View.StorefrontTools.Constants.ErrorMsg['unableToRemoveProduct'];
      }

      // show prompt to user, and refresh if needed
      var dialogView = M.View.InfoDialog.createWithPrimaryAndOptSecondaryButton(
        dialog_title,
        error_msg,
        {
          primaryButtonText: 'ok'
        },
        {
          hideCloseButton: true,
          closeOnEscape: false
        });
      dialogView.render();
      dialogView.bind('close', function() {
        window.location.reload();
      });
    },

  });

  return {
  };

});
